"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var tasks;
        (function (tasks) {
            var map;
            (function (map) {
                class InitArgs {
                    constructor() {
                        this.userGroups = [];
                        this.users = [];
                        this.userLatLng = appn.emptyString;
                        this.userHasDataEntryAccess = false;
                        this.dateFilter = appn.emptyString;
                        this.tasksEdit = appn.emptyString;
                        this.tasksMap = appn.emptyString;
                        this.tasksMapData = appn.emptyString;
                        this.taskRecurringEdit = appn.emptyString;
                        this.taskIndex = appn.emptyString;
                    }
                }
                let _initArgs;
                let _pagingToolbar;
                let _mapInDialog;
                let _mapMain;
                let _topPopupContent = appn.emptyString;
                let _isTop = true;
                function init(args) {
                    _initArgs = args;
                    createPagingToolbar();
                    createMapInDialog();
                    createMapMain();
                    addEvents();
                }
                map.init = init;
                appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function (channel, data) {
                    if (!_mapMain || !_mapMain.map)
                        return;
                    _mapMain.map.invalidateSize();
                });
                function addEvents() {
                    appn.dialog.showLoading();
                    appn.dateFilter.init(_initArgs.dateFilter);
                    $('#clearParentTask').on('click', function (e) {
                        appn.location.navTo(_initArgs.tasksMap);
                    });
                    if ($('#ParentTaskId').val() !== undefined)
                        $(document).on('click', '.btn-resetFilters', function (e) {
                            appn.location.navTo(_initArgs.tasksMap);
                        });
                    appn.taskTemplateFilter.init();
                    _mapMain.usersColorClasses = [];
                    $('.users-legend ul li').each(function (i, item) {
                        var _a, _b, _c;
                        const colorClasses = (_c = (_b = (_a = $(item)) === null || _a === void 0 ? void 0 : _a.attr('class')) === null || _b === void 0 ? void 0 : _b.split(' ')) !== null && _c !== void 0 ? _c : [];
                        colorClasses.forEach(function (colorClass, index) {
                            if (colorClass.contains('color-brand-'))
                                _mapMain.usersColorClasses.push({ userId: $(item).prop('id'), colorClass: colorClass });
                        });
                    });
                    _mapMain.templateTypesColorClasses = [];
                    $('.template-type-legend ul li').each(function (i, item) {
                        var _a, _b, _c;
                        const colorClasses = (_c = (_b = (_a = $(item)) === null || _a === void 0 ? void 0 : _a.attr('class')) === null || _b === void 0 ? void 0 : _b.split(' ')) !== null && _c !== void 0 ? _c : [];
                        for (let ix = 0; ix < colorClasses.length; ix++)
                            if (colorClasses[ix].indexOf('color-brand-') !== -1) {
                                _mapMain.templateTypesColorClasses.push({ name: $(item).prop('id'), colorClass: colorClasses[ix] });
                                break;
                            }
                    });
                    _mapMain.setColorBy(appn.emptyString);
                    $('#ColorByStatus,#ColorByUser,#ColorByTemplateType').off().on('change', function () {
                        const id = $(this).prop('id');
                        if (id === 'ColorByStatus')
                            _mapMain.setColorBy('statuses');
                        if (id === 'ColorByUser')
                            _mapMain.setColorBy('users');
                        if (id === 'ColorByTemplateType')
                            _mapMain.setColorBy('templateTypes');
                        _mapMain.getMapDataFromServer(true);
                    });
                    _mapMain.initmap();
                    _pagingToolbar.init();
                    _mapMain.getMapDataFromServer(true);
                }
                function createPagingToolbar() {
                    _pagingToolbar = {
                        init: function () {
                            $('#GoPrevious').on('click', function () {
                                if (!appn.ui.isElementDisabled($('#GoPrevious'))) {
                                    _pagingToolbar.pageNum--;
                                    _mapMain.getMapDataFromServer();
                                }
                            });
                            $('#GoNext').on('click', function () {
                                if (!appn.ui.isElementDisabled($('#GoNext'))) {
                                    _pagingToolbar.pageNum++;
                                    _mapMain.getMapDataFromServer();
                                }
                            });
                        },
                        pageSize: 100,
                        pageNum: 1,
                        totalRecords: 0,
                        updateUi: function (data) {
                            _pagingToolbar.totalRecords = data.TotalRecords;
                            _pagingToolbar.totalWithoutLocation = data.TotalWithoutLocation;
                            let totalText = T('No results found');
                            if (_pagingToolbar.totalRecords > 100) {
                                const totalRecs = _pagingToolbar.totalRecords;
                                const startRec = ((_pagingToolbar.pageSize * _pagingToolbar.pageNum) - _pagingToolbar.pageSize) + 1;
                                const lastRec = Math.min((_pagingToolbar.pageSize * _pagingToolbar.pageNum), totalRecs);
                                totalText = T('Showing {0} to {1} of {2} Tasks', startRec, lastRec, totalRecs);
                                $('.pagingToolbarTaskMap-inner').show();
                            }
                            else
                                $('.pagingToolbarTaskMap-inner').hide();
                            $('#TotalsText').html(`${totalText} <i class="fa fa-question-circle" title="The map displays 100 pins at a time when a location is set."></i>`);
                            if ((_pagingToolbar.pageSize * _pagingToolbar.pageNum) < _pagingToolbar.totalRecords)
                                appn.ui.enableElement($('#GoNext'));
                            else
                                appn.ui.disableElement($('#GoNext'));
                            if (_pagingToolbar.pageNum > 1)
                                appn.ui.enableElement($('#GoPrevious'));
                            else
                                appn.ui.disableElement($('#GoPrevious'));
                        }
                    };
                }
                function createMapInDialog() {
                    _mapInDialog = {
                        map: {},
                        currentLatLon: {},
                        marker: {},
                        initmap: function (lat, lon) {
                            const savedLat = lat;
                            if (savedLat !== 0) {
                                _mapInDialog.map = appn.ui.mapInit('mapInDialog', 0, 0, 11, false);
                                _mapInDialog.currentLatLon = new L.LatLng(savedLat, lon);
                                _mapInDialog.initMarker();
                                _mapInDialog.map.setView(_mapInDialog.currentLatLon, 15);
                            }
                        },
                        initMarker: function () {
                            const icon = L.divIcon({
                                html: '<div class="appn-mapPin"></div><div class="appn-mapShadow"></div>'
                            });
                            _mapInDialog.marker = new L.Marker(_mapInDialog.currentLatLon, { draggable: false, icon: icon });
                            _mapInDialog.map.addLayer(_mapInDialog.marker);
                        }
                    };
                }
                function createMapMain() {
                    _mapMain = {
                        map: {},
                        markersAdded: [],
                        resultsWithoutGps: [],
                        totalEntries: 0,
                        totalWithoutLocation: 0,
                        firstPopup: null,
                        firstEntryLatLng: null,
                        tasksToRender: [],
                        usersColorClasses: [],
                        templateTypesColorClasses: [],
                        updateTotalEntries: function () {
                            _mapMain.totalEntries = _pagingToolbar.totalRecords + _pagingToolbar.totalWithoutLocation;
                            let totalText = '<i class="fa fa-search text-danger"></i><span class="ml-2">' + T('No results found') + '</span>';
                            if (_mapMain.totalEntries > 0)
                                totalText = T('<b>{0}</b> Tasks', _mapMain.totalEntries);
                            const currentDateSelection = $('.appnDateFilter li.active .appnDateFilter-typeName').text();
                            totalText += T(' for {0}', currentDateSelection.toLowerCase());
                            $('.header-text .totalShowing').html(totalText);
                        },
                        updateNoLatLongEntries: function () {
                            if (_pagingToolbar.totalWithoutLocation > 0) {
                                const statusToFilterBy = appn.dataTable.getStateOrDefault('statusFilter', $('#statusFilter').val());
                                if (!statusToFilterBy.value || statusToFilterBy.value === 'All')
                                    statusToFilterBy.value = appn.emptyString;
                                const userToFilterBy = appn.dataTable.getStateOrDefault('userFilter', $('#userFilter').val());
                                if (!userToFilterBy.value || userToFilterBy.value === 'All')
                                    userToFilterBy.value = appn.emptyString;
                                const groupToFilterBy = appn.dataTable.getStateOrDefault('userGroupFilter', $('#userGroupFilter').val());
                                if (!groupToFilterBy.value || groupToFilterBy.value === 'All')
                                    groupToFilterBy.value = appn.emptyString;
                                const appnDateFilterValue = appn.dateFilter.getStateOrDefault();
                                let url = appn.location.buildUrl(_initArgs.taskIndex, [
                                    { name: 'template', value: appn.taskTemplateFilter.getStateOrDefault().value },
                                    { name: 'status', value: statusToFilterBy.value },
                                    { name: 'user', value: userToFilterBy.value },
                                    { name: 'userGroup', value: groupToFilterBy.value },
                                    { name: 'date', value: appnDateFilterValue.type },
                                    { name: 'dateFrom', value: encodeURIComponent(appnDateFilterValue.fromDate) },
                                    { name: 'dateTo', value: encodeURIComponent(appnDateFilterValue.toDate) },
                                    { name: 'parentTaskId', value: $('#ParentTaskId').val() || '' },
                                    { name: 'location', value: "ShowWithoutLocation" }
                                ]);
                                let totalText = `<a href="#" id="withoutLocationLink">${T("{0} without location", _pagingToolbar.totalWithoutLocation)}</a>`;
                                $('.header-text .totalNotShowing').html(totalText).show();
                                $('#withoutLocationLink').on('click', function (e) {
                                    e.preventDefault();
                                    appn.location.navTo(url);
                                });
                            }
                            else
                                $('.header-text .totalNotShowing').hide();
                        },
                        removeMarkers: function () {
                            for (let i = 0; i < _mapMain.markersAdded.length; i++)
                                _mapMain.map.removeLayer(_mapMain.markersAdded[i]);
                            _mapMain.markersAdded = [];
                        },
                        initmap: function () {
                            _mapMain.map = appn.ui.mapInit('mapMain', 0, 0, 11, false);
                        },
                        setColorBy: function (colorBy) {
                            if (colorBy === appn.emptyString) {
                                colorBy = appn.localStorage.getItem('map_defaultColorBy');
                                if (!colorBy)
                                    colorBy = 'users';
                            }
                            appn.localStorage.setItem('map_defaultColorBy', colorBy);
                            if (colorBy === 'statuses') {
                                $('#ColorByStatus').prop('checked', true);
                                $('#ColorByUser').prop('checked', false);
                                $('#ColorByTemplateType').prop('checked', false);
                            }
                            if (colorBy === 'users') {
                                $('#ColorByUser').prop('checked', true);
                                $('#ColorByStatus').prop('checked', false);
                                $('#ColorByTemplateType').prop('checked', false);
                            }
                            if (colorBy === 'templateTypes') {
                                $('#ColorByTemplateType').prop('checked', true);
                                $('#ColorByStatus').prop('checked', false);
                                $('#ColorByUser').prop('checked', false);
                            }
                        },
                        renderDataOnMap: function (serverResponse) {
                            createMap_renderDataOnMap(serverResponse);
                        },
                        showTaskDetailsDialog: function (event) {
                            createMap_showTaskDetailsDialog(event);
                        },
                        getMapDataFromServer: function (resetPaging) {
                            createMap_getMapDataFromServer(resetPaging);
                        }
                    };
                }
                function createMap_renderDataOnMap(serverResponse) {
                    const latlng = _initArgs.userLatLng.split(',');
                    _mapMain.removeMarkers();
                    _mapMain.resultsWithoutGps = [];
                    _mapMain.tasksToRender = [];
                    _mapMain.firstPopup = null;
                    _mapMain.firstEntryLatLng = new L.LatLng(latlng[0], latlng[1]);
                    const bounds = new Array();
                    for (let i = 0; i < serverResponse.TaskMapDataItems.length; i++) {
                        let colorToAdd = appn.emptyString;
                        let colorClassToAdd = appn.emptyString;
                        if ($('#ColorByStatus').prop('checked'))
                            if (!serverResponse.TaskMapDataItems[i].IsTaskRecurring) {
                                const status = serverResponse.TaskMapDataItems[i].Status.trim().toLowerCase();
                                let statusToCompare = status;
                                if (serverResponse.TaskMapDataItems[i].CustomStatus)
                                    statusToCompare = serverResponse.TaskMapDataItems[i].CustomStatus.trim().toLowerCase();
                                if (statusToCompare)
                                    for (let j = 0; j < serverResponse.MergedStatuses.length; j++) {
                                        if (!serverResponse.MergedStatuses[j].Color || !serverResponse.MergedStatuses[j].Color.trim())
                                            break;
                                        if (serverResponse.MergedStatuses[j].Value.trim().toLowerCase() === statusToCompare) {
                                            colorToAdd = serverResponse.MergedStatuses[j].Color;
                                            break;
                                        }
                                    }
                                const defaultStatusColorsParsed = appn.emptyString;
                                if (!colorToAdd)
                                    colorToAdd = defaultStatusColorsParsed[serverResponse.TaskMapDataItems[i].Status];
                            }
                        if ($('#ColorByUser').prop('checked'))
                            $(_mapMain.usersColorClasses).each(function (ii, item) {
                                if (item.userId === serverResponse.TaskMapDataItems[i].AppUserId) {
                                    if (item.colorClass)
                                        colorClassToAdd = item.colorClass;
                                    return false;
                                }
                            });
                        if ($('#ColorByTemplateType').prop('checked'))
                            $(_mapMain.templateTypesColorClasses).each(function (ii, item) {
                                if (item.name === serverResponse.TaskMapDataItems[i].TemplateName) {
                                    colorClassToAdd = item.colorClass;
                                    return false;
                                }
                            });
                        const eventTitle = serverResponse.TaskMapDataItems[i].TaskName;
                        _mapMain.tasksToRender.push({
                            id: serverResponse.TaskMapDataItems[i].Id,
                            parentId: serverResponse.TaskMapDataItems[i].ParentId,
                            title: eventTitle,
                            start: serverResponse.TaskMapDataItems[i].Start,
                            end: serverResponse.TaskMapDataItems[i].End,
                            color: colorToAdd,
                            colorClass: colorClassToAdd,
                            taskType: serverResponse.TaskMapDataItems[i].TemplateName,
                            taskStatus: T(serverResponse.TaskMapDataItems[i].Status),
                            isRecurring: serverResponse.TaskMapDataItems[i].IsTaskRecurring,
                            startBy: serverResponse.TaskMapDataItems[i].StartBy,
                            startByTimeAgo: serverResponse.TaskMapDataItems[i].StartByTimeAgo,
                            completeBy: serverResponse.TaskMapDataItems[i].CompleteBy,
                            completeByTimeAgo: serverResponse.TaskMapDataItems[i].CompleteByTimeAgo,
                            templateName: serverResponse.TaskMapDataItems[i].TemplateName,
                            additionalInfo: serverResponse.TaskMapDataItems[i].AdditionalInfo,
                            recurringTaskName: serverResponse.TaskMapDataItems[i].RecurringTaskName,
                            taskRecurringId: serverResponse.TaskMapDataItems[i].TaskRecurringId,
                            taskId: serverResponse.TaskMapDataItems[i].TaskId,
                            taskName: serverResponse.TaskMapDataItems[i].TaskName,
                            completeAtText: serverResponse.TaskMapDataItems[i].CompleteAtText,
                            completeAtLat: serverResponse.TaskMapDataItems[i].CompleteAtLat,
                            completeAtLon: serverResponse.TaskMapDataItems[i].CompleteAtLon,
                            assignedToId: serverResponse.TaskMapDataItems[i].AssignedToId,
                            actualCompleteLat: serverResponse.TaskMapDataItems[i].ActualCompleteLat,
                            actualCompleteLon: serverResponse.TaskMapDataItems[i].ActualCompleteLon,
                            completedTimeAgo: serverResponse.TaskMapDataItems[i].CompletedTimeAgo,
                            assignedToName: serverResponse.TaskMapDataItems[i].AssignedTo,
                            userColorCode: serverResponse.TaskMapDataItems[i].UserColorCode
                        });
                    }
                    const markers = L.markerClusterGroup();
                    for (let i = 0; i < _mapMain.tasksToRender.length; i++) {
                        let lat = _mapMain.tasksToRender[i].completeAtLat;
                        let lon = _mapMain.tasksToRender[i].completeAtLon;
                        if (_mapMain.tasksToRender[i].taskStatus === 'Completed' && (!lat || lat === 0 || !lon || lon === 0)) {
                            lat = _mapMain.tasksToRender[i].actualCompleteLat;
                            lon = _mapMain.tasksToRender[i].actualCompleteLon;
                        }
                        const newCoordinate = new L.LatLng(lat, lon, 1);
                        bounds.push(newCoordinate);
                        const pinColourClass = _mapMain.tasksToRender[i].colorClass;
                        const pinUserColor = _mapMain.tasksToRender[i].userColorCode;
                        let icon;
                        if ($('#ColorByStatus').prop('checked'))
                            icon = L.divIcon({
                                html: `<div class="appn-mapPin" style="background-color:${_mapMain.tasksToRender[i].color}; border-color:${_mapMain.tasksToRender[i].color}; opacity: 0.7;"></div>` +
                                    `<div class="appn-mapShadow ${pinColourClass}"></div>`,
                                className: 'dummy'
                            });
                        else if (!$('#ColorByTemplateType').prop('checked') && pinUserColor)
                            icon = L.divIcon({
                                html: `<div class="appn-mapPin" style="background-color:${pinUserColor}; border-color:${pinUserColor};"></div><div class="appn-mapShadow" style="background-color:${pinUserColor}; border-color:${pinUserColor};"></div>`,
                                className: 'dummy'
                            });
                        else
                            icon = L.divIcon({
                                html: `<div class="appn-mapPin ${pinColourClass}"></div><div class="appn-mapShadow ${pinColourClass}"></div>`,
                                className: 'dummy'
                            });
                        const newMarker = new L.Marker(newCoordinate, { icon: icon });
                        markers.addLayer(newMarker);
                        let buttons = appn.emptyString;
                        if (_initArgs.userHasDataEntryAccess)
                            buttons = `<br /><button class="btn btn-link btn-sm pb-0 btn-task-viewDetails">${T('View Details')}</button>`;
                        if (_mapMain.tasksToRender[i].parentId === _mapMain.tasksToRender[i].id && !window.location.href.contains(_mapMain.tasksToRender[i].parentId))
                            buttons += `<a href="${_initArgs.tasksMap}?parentTaskId=${_mapMain.tasksToRender[i].parentId}" class="btn btn-link btn-sm pb-0">${T('Show Children')}</a>`;
                        if (buttons.hasValue())
                            buttons += '<br />';
                        const popupText = `<div class="appnMapPopup" data-taskid="${_mapMain.tasksToRender[i].id}">` +
                            `<h5>${_mapMain.tasksToRender[i].title}</h5><span>${T('Start by {0}', _mapMain.tasksToRender[i].startBy)}</span><br />` +
                            `${_mapMain.tasksToRender[i].assignedToName}<br />` +
                            `<span>${_mapMain.tasksToRender[i].taskStatus}</span>` +
                            `${buttons}` +
                            `<span class="text-muted leaflet-popup-gpsstring"><i class="fa fa-map-marker"></i> ${lat} ${lon}</span></div>`;
                        const popup = newMarker.bindPopup(popupText).on('popupopen', function (popup) {
                            _isTop = popup.popup._content === _topPopupContent;
                            $('.btn-task-viewDetails').on('click', function (e) {
                                const taskId = $(this).closest('.appnMapPopup').data('taskid');
                                $.each(_mapMain.tasksToRender, function (index, task) {
                                    if (task.id === taskId) {
                                        _mapMain.showTaskDetailsDialog(task);
                                        return false;
                                    }
                                });
                            });
                            $('abbr.timeago').timeago();
                        });
                        if (!_mapMain.firstPopup) {
                            _mapMain.firstPopup = popup;
                            _topPopupContent = _mapMain.firstPopup._popup._content;
                            _mapMain.firstEntryLatLng = newCoordinate;
                        }
                    }
                    _mapMain.markersAdded.push(markers);
                    _mapMain.map.addLayer(markers);
                    _mapMain.updateTotalEntries();
                    _mapMain.updateNoLatLongEntries();
                    if (_mapMain.firstPopup)
                        _mapMain.firstPopup.openPopup();
                    if (bounds.length > 0)
                        _mapMain.map.fitBounds(bounds);
                    else
                        _mapMain.map.setView(_mapMain.firstEntryLatLng, 6);
                }
                function createMap_showTaskDetailsDialog(event) {
                    if (event.isRecurring) {
                        const buttonConfig = {};
                        buttonConfig.schedule = {
                            label: T('Schedule'),
                            className: 'btn-info',
                            callback: function () {
                                appn.location.navTo(`${_initArgs.taskRecurringEdit}/${event.id}`, [
                                    {
                                        name: 'bk',
                                        value: 'Calendar_Tasks'
                                    }
                                ]);
                                return true;
                            }
                        };
                        buttonConfig.details = {
                            label: '<span>' + T('Details') + '</span>',
                            className: 'btn-success',
                            callback: function () {
                                appn.location.navTo(_initArgs.tasksEdit, [
                                    { name: 'taskRecurringId', value: event.id },
                                    { name: 'bk', value: 'Calendar_Tasks' }
                                ]);
                                return true;
                            }
                        };
                        const modalContent = `<div><div class="form-group">` +
                            `<label class="col-form-label col-sm-4">${T('Recurring Task')}</label>` +
                            `<div class="col-sm-8">` +
                            `<label class="col-form-label">${event.recurringTaskName}</label>` +
                            `</div></div>` +
                            `<div class="form-group ${event.templateName ? '' : 'hide'}">` +
                            `<label class="col-form-label col-sm-4">${T('Template')}</label>` +
                            `<div class="col-sm-8">` +
                            `<label class="col-form-label">${event.templateName}</label>` +
                            `</div></div>` +
                            `<div class="form-group">` +
                            `<label class="col-form-label col-sm-4">${T('Start By')}</label>` +
                            `<label class="col-form-label col-sm-8">${event.startBy}</label>` +
                            `<label class="col-form-label col-sm-4">${T('Complete By')}</label>` +
                            `<label class="col-form-label col-sm-8">${event.completeBy}</label>` +
                            `</div>` +
                            `<div class="form-group ${event.allDay ? '' : 'hide'}">` +
                            `<label class="col-form-label col-sm-4">${T('All Day')}</label>` +
                            `<div class="col-sm-8">` +
                            `<label class="col-form-label"><i class="fa fa-check"></i></label>` +
                            `</div></div>` +
                            `<div class="form-group ${event.additionalInfo ? '' : 'hide'}">` +
                            `<label class="col-form-label col-sm-4">${T('Additional Info')}</label>` +
                            `<div class="col-sm-5">` +
                            `<label class="col-form-label">${event.additionalInfo}</label>` +
                            `</div></div></div>`;
                        appn.dialog.custom({
                            message: modalContent,
                            title: `${event.title}`,
                            modalColor: 'modal-info',
                            closeButton: true,
                            buttons: buttonConfig
                        });
                    }
                    else {
                        let recurId = '';
                        if (event.isRecurring)
                            recurId = event.taskRecurringId;
                        const queryString = appn.location.buildQueryString([
                            { name: 'id', value: event.id },
                            { name: 'taskRecurringId', value: recurId },
                            { name: 'isLoadingIframe', value: 'true' },
                            { name: 'returnAction', value: 'Map' }
                        ]);
                        appn.iframe.openModal({
                            url: `${_initArgs.tasksEdit}/${queryString}`,
                            size: 'modal-xl'
                        }).then(function (modal) {
                            modal.on('hidden.bs.modal', function () {
                                appn.location.reloadCurrentPage();
                            });
                            addItemEvents(event, modal);
                        });
                    }
                }
                function createMap_getMapDataFromServer(resetPaging) {
                    appn.dialog.showLoading();
                    if (resetPaging)
                        _pagingToolbar.pageNum = 1;
                    const statusToFilterBy = appn.dataTable.getStateOrDefault('statusFilter', $('#statusFilter').val());
                    if (!statusToFilterBy.value || statusToFilterBy.value === 'All')
                        statusToFilterBy.value = appn.emptyString;
                    const userToFilterBy = appn.dataTable.getStateOrDefault('userFilter', $('#userFilter').val());
                    if (!userToFilterBy.value || userToFilterBy.value === 'All')
                        userToFilterBy.value = appn.emptyString;
                    const appnDateFilterValue = appn.dateFilter.getStateOrDefault();
                    const params = appn.location.buildQueryString([
                        { name: 'v', value: new Date().getTime() },
                        { name: 'templateId', value: appn.taskTemplateFilter.getStateOrDefault().value },
                        { name: 'statusFilter', value: statusToFilterBy.value },
                        { name: 'userFilterId', value: userToFilterBy.value },
                        { name: 'dateFilter', value: appnDateFilterValue.type },
                        { name: 'dateFilterFrom', value: encodeURIComponent(appnDateFilterValue.fromDate) },
                        { name: 'dateFilterTo', value: encodeURIComponent(appnDateFilterValue.toDate) },
                        { name: 'pageSize', value: _pagingToolbar.pageSize },
                        { name: 'pageNum', value: (_pagingToolbar.pageNum - 1) },
                        { name: 'parentTaskId', value: $('#ParentTaskId').val() || '' }
                    ]);
                    let userGroupFilterParam = appn.emptyString;
                    if (_initArgs.userGroups.length > 0) {
                        const userGroupToFilterBy = appn.dataTable.getStateOrDefault('userGroupFilter', $('#userGroupFilter').val());
                        if (!userGroupToFilterBy.value || userGroupToFilterBy.value === 'All')
                            userGroupToFilterBy.value = appn.emptyString;
                        userGroupFilterParam = `&userGroupFilterId=${userGroupToFilterBy.value}`;
                    }
                    const url = _initArgs.tasksMapData + params + userGroupFilterParam;
                    appn.ajax.post({
                        url: url,
                        dataType: 'json',
                        done: function (data) {
                            getMapDataFromServer_AjaxPost_Done(data);
                        },
                        fail: function () {
                            appn.dialog.alert({
                                modalColor: 'modal-danger',
                                title: T('Map Data Load Failed'),
                                message: T('Failed to load map data. Please sign out and sign in again. Contact support if this problem persists.'),
                                buttons: {
                                    ok: {
                                        label: '<span>' + T('OK') + '</span>',
                                        className: 'btn-success'
                                    }
                                },
                                autoHeaderIcon: false
                            });
                            appn.dialog.hideLoading();
                        }
                    });
                }
                function getMapDataFromServer_AjaxPost_Done(data) {
                    _mapMain.renderDataOnMap(data);
                    _pagingToolbar.updateUi(data);
                    $('.mapHeader .header-filters').html(appn.emptyString);
                    appn.sideFilterAndContent.appendShowButton($('.mapHeader .header-filters'));
                    $('.mapHeader .header-filters ').prepend(appn.elementBuilder.buildTaskStatusSelect(data.MergedStatuses, 'statusFilter', 'saveMeState'));
                    $('.mapHeader .header-filters ').prepend(appn.elementBuilder.buildSelect(_initArgs.users, 'userFilter', 'saveMeState select2-noinit'));
                    if (_initArgs.userGroups.length > 0)
                        $('.mapHeader .header-filters ').prepend(appn.elementBuilder.buildSelect(_initArgs.userGroups, 'userGroupFilter', 'saveMeState'));
                    $('.statuses-legend ul li').remove();
                    let statusesToAddLegend = appn.emptyString;
                    for (let i = 0; i < data.MergedStatuses.length; i++)
                        statusesToAddLegend += `<li style="background-color:${data.MergedStatuses[i].Color};" role="presentation" class="folder " id="${data.MergedStatuses[i].Value}">` +
                            `<span class="text-whitesmoke" id="">${data.MergedStatuses[i].Display}</span></li>`;
                    $('.statuses-legend ul').append(statusesToAddLegend);
                    appn.saveMeState.init(function () {
                        _mapMain.getMapDataFromServer(true);
                    }, function () {
                        _mapMain.setColorBy('users');
                        _mapMain.getMapDataFromServer(true);
                    }, '.mapHeader .header-filters ');
                    _mapMain.updateTotalEntries();
                    _mapMain.updateNoLatLongEntries();
                    if ((data.TaskMapDataItems.length - _mapMain.resultsWithoutGps.length) > 0) {
                        $('.header-filters').prepend(`<button id="btnShowMostRecent" title="${T('Displays the popup for the most recent Task Map Pin.')}" class="btn-sm btn btn-info">${T('Latest')}</button>`);
                        $('#btnShowMostRecent').off().on('click', function (e) {
                            e.preventDefault();
                            const shake = _isTop;
                            const bounds = _mapMain.map.getBounds();
                            const target = _mapMain.firstEntryLatLng;
                            const isTargetInView = target.lat >= bounds._southWest.lat && target.lat <= bounds._northEast.lat && target.lng >= bounds._southWest.lng && target.lng <= bounds._northEast.lng;
                            if (!isTargetInView)
                                _mapMain.map.setView(target);
                            _mapMain.firstPopup.openPopup();
                            if (shake)
                                appn.utils.shake($(_mapMain.firstPopup._popup._wrapper));
                            $('abbr.timeago').timeago();
                        });
                    }
                    appn.actionButtons.renderNavbarActionButtons([
                        {
                            buttonId: 'addnew',
                            buttonType: 'AddNew'
                        }
                    ], appn.requestUser.isUserOrHigher);
                    $('#addnew').off().on('click', function (e) {
                        e.preventDefault();
                        appn.tasks.showAddNewDialog(false, false, undefined, undefined, false, T('Map'));
                    });
                    appn.select.init();
                    appn.tooltip.init();
                    appn.select.init({ selector: '#userFilter', minimumResultsForSearch: '25' });
                    appn.dialog.hideLoading();
                }
                function addItemEvents(event, modal) {
                    $(modal).on('click', 'button[value="Details"]', function (e) {
                        e.preventDefault();
                        const isrecur = event.isRecurring;
                        if (isrecur)
                            appn.location.navTo(_initArgs.tasksEdit, [
                                { name: 'taskRecurringId', value: event.taskRecurringId },
                                { name: 'returnAction', value: 'Map' }
                            ]);
                        else
                            appn.location.navTo(_initArgs.tasksEdit, [
                                { name: 'id', value: event.id },
                                { name: 'returnAction', value: 'Map' }
                            ]);
                    });
                    $(modal).on('click', 'button[value="Schedule"]', function (e) {
                        e.preventDefault();
                        appn.location.navTo(_initArgs.taskRecurringEdit, [
                            { name: 'id', value: event.taskRecurringId },
                            { name: 'returnAction', value: 'Map' }
                        ]);
                    });
                    $(modal).on('click', 'button[value="Children"]', function (e) {
                        e.preventDefault();
                        appn.location.navTo(_initArgs.tasksMap, [
                            {
                                name: 'parentTaskId',
                                value: event.parentId
                            }
                        ]);
                    });
                }
            })(map = tasks.map || (tasks.map = {}));
        })(tasks = views.tasks || (views.tasks = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
